// extracted by mini-css-extract-plugin
export var fadeIn = "_gh-1";
export var modalContent = "_gh-3";
export var overlay = "_gh-0";
export var popoverContent = "_gh-2";
export var results = "_gh-5";
export var searchInputWrapper = "_gh-4";